import {
  IInstructorApprover,
  IError,
  IQueryHookOptions,
} from '@comptia-sso/core';
import { useQuery } from 'react-query';

// Services.
import { getInstructorApproversByInstitution } from 'services';

type UseInstructorApproversByInstitution = [
  IInstructorApprover[],
  IQueryHookOptions,
];

export const useInstructorApproversByInstitution = (
  institutionId = '',
): UseInstructorApproversByInstitution => {
  const {
    data = [] as IInstructorApprover[],
    error,
    isError,
    isLoading,
  } = useQuery<IInstructorApprover[], IError>(
    ['instructor-approvers', 'institution', institutionId],
    () => getInstructorApproversByInstitution(institutionId),
    {
      enabled: !!institutionId,
    },
  );

  return [data, { error, isError, isLoading }];
};
